import { Box } from "@mui/material"
import map from "../lep_map.webp"

export const WaterAccess = () => {
    return (
        <div>
            Info on water access, dock space, and link to rentals.
        </div>
    )
}